/** @namespace Bodypwa/Util/Sentry/EnvCheck/isProduction */
export function isProduction() {
    const { NODE_ENV = 'production' } = process.env || {};
    const { hostname } = window.location;

    return NODE_ENV === 'production' && !(hostname.includes('staging') || hostname.includes('pwa'));
}
